import React from 'react';
import { View, TouchableOpacity, StyleSheet, Platform } from 'react-native';
import { getResponsiveValue } from '../styles/breakpoints';

// Helper function to detect mouse support
const hasMouseSupport = () => {
    return Platform.OS === 'web' && window.matchMedia('(pointer: fine)').matches;
};

export function ItemWrapper({
    children,
    isSelected,
    onPress,
    onLongPress,
    isDragging = false,
    itemType = 'file'
}) {
    return (
        <View
            style={[
                styles.container,
                isSelected && styles.selectedContainer,
                isDragging && styles.draggingContainer,
            ]}
        >
            <div
                {...(hasMouseSupport() && {
                    onContextMenu: (e) => {
                        e.preventDefault();
                        onLongPress && onLongPress(e);
                    }
                })}
                style={{
                    width: '100%',
                    height: '100%',
                }}
            >
                <TouchableOpacity
                    onPress={onPress}
                    onLongPress={onLongPress}
                    style={styles.touchableArea}
                    activeOpacity={0.8}
                >
                    {children}
                </TouchableOpacity>
            </div>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        width: getResponsiveValue({
            mobile: '48%',
            tablet: '31%',
            laptop: '22%',
            desktop: '22%'
        }),
        minWidth: 160,
        height: getResponsiveValue({
            mobile: 120,
            tablet: 120,
            laptop: 130,
            desktop: 130
        }),
        marginBottom: 15,
        borderRadius: 12,
        overflow: 'hidden',
        borderWidth: 2,
        borderColor: 'transparent',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 4,
        elevation: 3,
    },
    selectedContainer: {
        borderColor: '#ffffff',
        shadowColor: '#ffffff',
        shadowOpacity: 0.3,
    },
    draggingContainer: {
        opacity: 0.5,
        transform: [{ scale: 0.95 }],
    },
    touchableArea: {
        width: '100%',
        height: '100%',
    },
});
